module.exports = __webpack_public_path__ + "img/targeted_procedures.87b581e4.svg";